import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_cashbook_txn_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
	hdr_guid: fromDatatype.GuidDataFieldInterface;
	gen_doc_hdr_guid: fromDatatype.TextDatatypeInterface;
	gen_doc_line_guid: fromDatatype.TextDatatypeInterface;
	imported_file_line_guid: fromDatatype.GuidDataFieldInterface;
	name: fromDatatype.TextDatatypeInterface;
	descr: fromDatatype.TextDatatypeInterface;
	ccy_code: fromDatatype.TextDatatypeInterface;
	amt_debit: fromDatatype.NumericDatatypeInterface;
	amt_credit: fromDatatype.NumericDatatypeInterface;
	txn_amount: fromDatatype.NumericDatatypeInterface;
	txn_type: fromDatatype.VarcharDatatypeInterface;
	doc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
	doc_hdr_server_doc_1: fromDatatype.VarcharDatatypeInterface;
	open_amount: fromDatatype.NumericDatatypeInterface;
	reference_num_1: fromDatatype.TextDatatypeInterface;
	reference_num_2: fromDatatype.TextDatatypeInterface;
	reference_num_3: fromDatatype.TextDatatypeInterface;
	reference_num_4: fromDatatype.TextDatatypeInterface;
	reference_num_5: fromDatatype.TextDatatypeInterface;
	date_txn_doc: fromDatatype.TimestampTzDatatypeInterface;
	data_entry_date: fromDatatype.TimestampTzDatatypeInterface;
	date_posting: fromDatatype.TimestampTzDatatypeInterface;
	glcode_guid: fromDatatype.GuidDataFieldInterface;
	guid_cashbook: fromDatatype.GuidDataFieldInterface;
	guid_profit_center: fromDatatype.GuidDataFieldInterface;
	guid_segment: fromDatatype.GuidDataFieldInterface;
	guid_project: fromDatatype.GuidDataFieldInterface;
	guid_dimension: fromDatatype.GuidDataFieldInterface;
	guid_branch: fromDatatype.GuidDataFieldInterface;
	guid_comp: fromDatatype.GuidDataFieldInterface;
	doc_source_guid: fromDatatype.GuidDataFieldInterface;
	doc_source_type: fromDatatype.TextDatatypeInterface;
	doc_source_url: fromDatatype.TextDatatypeInterface;
	doc_source_db: fromDatatype.TextDatatypeInterface;
	doc_source_table: fromDatatype.TextDatatypeInterface;
	doc_source_tablename: fromDatatype.TextDatatypeInterface;
	doc_source_software_name: fromDatatype.TextDatatypeInterface;
	label_json: fromDatatype.JsonDatatypeInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	status: fromDatatype.TextDatatypeInterface;
	revision: fromDatatype.GuidDataFieldInterface;
	vrsn: fromDatatype.TextDatatypeInterface;
	manual_adjustment_action: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_cashbook_txn_line_RowClass implements bl_fi_cashbook_txn_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
	hdr_guid: fromDatatype.GuidDataFieldInterface;
	gen_doc_hdr_guid: fromDatatype.TextDatatypeInterface;
	gen_doc_line_guid: fromDatatype.TextDatatypeInterface;
	imported_file_line_guid: fromDatatype.GuidDataFieldInterface;
	doc_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
	doc_hdr_server_doc_1: fromDatatype.VarcharDatatypeInterface;
	name: fromDatatype.TextDatatypeInterface;
	descr: fromDatatype.TextDatatypeInterface;
	ccy_code: fromDatatype.TextDatatypeInterface;
	amt_debit: fromDatatype.NumericDatatypeInterface;
	amt_credit: fromDatatype.NumericDatatypeInterface;
	txn_amount: fromDatatype.NumericDatatypeInterface;
	txn_type: fromDatatype.VarcharDatatypeInterface;
	open_amount: fromDatatype.NumericDatatypeInterface;
	reference_num_1: fromDatatype.TextDatatypeInterface;
	reference_num_2: fromDatatype.TextDatatypeInterface;
	reference_num_3: fromDatatype.TextDatatypeInterface;
	reference_num_4: fromDatatype.TextDatatypeInterface;
	reference_num_5: fromDatatype.TextDatatypeInterface;
	date_txn_doc: fromDatatype.TimestampTzDatatypeInterface;
	data_entry_date: fromDatatype.TimestampTzDatatypeInterface;
	date_posting: fromDatatype.TimestampTzDatatypeInterface;
	glcode_guid: fromDatatype.GuidDataFieldInterface;
	guid_cashbook: fromDatatype.GuidDataFieldInterface;
	guid_profit_center: fromDatatype.GuidDataFieldInterface;
	guid_segment: fromDatatype.GuidDataFieldInterface;
	guid_project: fromDatatype.GuidDataFieldInterface;
	guid_dimension: fromDatatype.GuidDataFieldInterface;
	guid_branch: fromDatatype.GuidDataFieldInterface;
	guid_comp: fromDatatype.GuidDataFieldInterface;
	doc_source_guid: fromDatatype.GuidDataFieldInterface;
	doc_source_type: fromDatatype.TextDatatypeInterface;
	doc_source_url: fromDatatype.TextDatatypeInterface;
	doc_source_db: fromDatatype.TextDatatypeInterface;
	doc_source_table: fromDatatype.TextDatatypeInterface;
	doc_source_tablename: fromDatatype.TextDatatypeInterface;
	doc_source_software_name: fromDatatype.TextDatatypeInterface;
	label_json: fromDatatype.JsonDatatypeInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	status: fromDatatype.TextDatatypeInterface;
	revision: fromDatatype.GuidDataFieldInterface;
	vrsn: fromDatatype.TextDatatypeInterface;
	manual_adjustment_action: fromDatatype.VarcharDatatypeInterface;
}